// extracted by mini-css-extract-plugin
export default {"container":"FriendDetail_container__E7pNf","contentBox":"FriendDetail_contentBox__sH0uf","formBox":"FriendDetail_formBox__wzJhm","formItem":"FriendDetail_formItem__lbjet"};